// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { safeJsonParse } from "@turnerBlueprint/XDL/Utilities";
import React, { useContext } from "react";

export interface OrderDetailsPaymentInfoStyles {
    titleText?: TypographyProps;
    wrapper?: InjectableCss;
    infoWrapper?: InjectableCss;
    text?: TypographyProps;
    mainTitle?: TypographyProps;
    poTitle?: TypographyProps;
}

export const orderDetailsPaymentInfoStyles: OrderDetailsPaymentInfoStyles = {};

const styles = orderDetailsPaymentInfoStyles;

const OrderDetailsPaymentInfo: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }
    const creditCardInfo = safeJsonParse(order.properties["creditCardInfo"]);

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.mainTitle}>{translate("Payment")}</Typography>
            {!creditCardInfo ? (
                <>
                    <Typography {...styles.poTitle}>{order.properties.termsDescription} </Typography>
                    {createWidgetElement("OrderDetails/OrderDetailsBillingAddress", { fields: {} })}
                </>
            ) : (
                <>
                    <Typography {...styles.titleText}>{translate("Credit Card")} </Typography>
                    <StyledWrapper {...styles.infoWrapper}>
                        {creditCardInfo.Description && (
                            <Typography {...styles.text}>{creditCardInfo.Description}</Typography>
                        )}
                        {creditCardInfo.ExpirationDate && (
                            <>
                                <Typography {...styles.text}>{translate("Exp")}</Typography>
                                <Typography {...styles.text}>{creditCardInfo.ExpirationDate}</Typography>
                            </>
                        )}
                    </StyledWrapper>
                    {createWidgetElement("OrderDetails/OrderDetailsCreditCardBillingAddress", { fields: {} })}
                </>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsPaymentInfo,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
